import apiInstance from "@services/Shared/instanceAxios";

const deleteMedia = (mediaId: string) =>
  apiInstance({
    url: `/media/${mediaId}/reset`,
    method: "post",
  });

export default deleteMedia;
